<template>
<div class="chapter">
<div class="inner_page">
<p class="fhd"><a id="page_ii"></a><span class="bold">Also by New Academia Publishing</span></p>
<p class="fpara">TURKEY’S MODERNIZATION: Refugees from Nazism and Atatürk’s Vision, by Arnold Reisman</p>
<p class="fpara">DOOMED TO REPEAT? Terrorism and the Lessons of History, Sean Brawley, ed.</p>
<p class="fpara">DETECTING THE BOMB: The Role of Seismology in the Cold War by Carl Romney</p>
<p class="fpara">SHOPPING FOR JESUS: Faith in Marketing in the USA, Dominic Janes, Ed.</p>
<p class="fpara">THE SOVIETIZATION OF EASTERN EUROPE: New Perspectives on the Postwar Period, Balázs Apor, Péter Apor, and E. A. Rees, eds.</p>
<p class="fpara">FROM THE HOLY LAND TO THE NEW JERUSALEM, by Arthur Grenke</p>
<p class="fpara">GOD, GREED, AND GENOCIDE: The Holocaust through the Centuries, by Arthur Grenke</p>
<p class="fpara">NATIONALISM, HISTORIOGRAPHY, AND THE (RE)CONSTRUCTION OF THE PAST, Claire Norton, ed.</p>
<p class="fpara">FROM PIETY TO POLITICS: The Evolution of Sufi Brotherhoods, by Barbara DeGorge</p>
<p class="fpara">SLAVIC THINKERS OR THE CREATION OF POLITIES: Intellectual History and Political Thought in Central Europe and the Balkans in the 19th Century, by Josette Baer</p>
<p class="fpara">ASPECTS OF BALKAN CULTURE: Social, Political, and Literary Perceptions, by Jelena Milojković-Djurić</p>
<p class="fpara">DANGER ZONES: A Diplomat’s Fight for America’s Interests, by John Gunther Dean</p>
<p class="fpara">WITNESS TO A CHANGING WORLD, by David D. Newsom</p>
<p class="fpara">AN ARCHITECT OF DEMOCRACY: Building a Mosaic of Peace, by James Robert Huntley</p>
<p class="fpara">BUSHELS AND BALES: A Food Soldier in the Cold War, by Howard L. Steele</p>
<p class="fpara">NINE LIVES: A Foreign Service Odyssey, by Allen C. Hansen</p>
<p class="fpara">ECHOES OF A DISTANT CLARION, by John G. Kormann</p>
<p class="fpara">PETER STRICKLAND: New London Shipmaster, Boston Merchant, First Consul to Senegal, by Stephen H. Grant</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_adcard.vue?bfbb6190